import { render, staticRenderFns } from "./OrcamentoEdicao.vue?vue&type=template&id=9b6413bc&scoped=true"
import script from "./OrcamentoEdicao.vue?vue&type=script&lang=js"
export * from "./OrcamentoEdicao.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoEdicao.vue?vue&type=style&index=0&id=9b6413bc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6413bc",
  null
  
)

export default component.exports